// src/portals/ExecutivePortal.jsx

import React from 'react';
import AdminPortal from '../components/AdminPortal';
import SuperAdminPanel from '../components/SuperAdminPanel';
import EnterpriseConsole from '../components/EnterpriseConsole';
import CoachPortal from './CoachPortal';

const ExecutivePortal = (props) => {
    const { activeTab, handleNavigate, isSuperAdmin, handlePreviewOrg, currentUser } = props;

    // Catch all Command Center sub-routes
    if (activeTab && (activeTab === 'command-center' || activeTab.startsWith('cc-'))) {
        const targetTab = activeTab === 'command-center' ? 'cc-overview' : activeTab;
        return <EnterpriseConsole activeTab={targetTab} onNavigate={handleNavigate} currentUser={currentUser} />;
    }

    switch (activeTab) {
        case 'admin': 
            return <AdminPortal navigateTo={handleNavigate} />;
        case 'super-admin':
            return isSuperAdmin ? 
                <SuperAdminPanel onExit={() => handleNavigate('admin')} onPreviewOrg={handlePreviewOrg} /> : 
                <div className="p-12 text-center">Restricted Access</div>;
        default:
            // If it's not an exec-specific tab, pass it down the chain
            return <CoachPortal {...props} />;
    }
};

export default ExecutivePortal;